import { type ReactElement } from 'react';

export const ArrowThinLeft = (): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.1074 4.89246L15.8921 5.67712L9.73243 11.8909L15.8391 18.0574L15.1074 18.8925L8.10743 11.8909L15.1074 4.89246Z"
        fill="currentColor"
      />
    </svg>
  );
};
